import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { environment } from "../../../environments/environment";
import { AuthData } from "../../shared/models/auth-data.model";
import { AuthLoginData } from "../../shared/models/auth-logindata.model";
import { PropertyDropDown } from '../../shared/models/property-dd.model';
import { CommonService } from './common.service';
import { PropertyService } from './property.service';
import { AuthService } from 'angularx-social-login';


const BACKEND_URL = environment.apiUrl + "/user";
const BACKEND_URL1 = environment.apiUrl + "/backblaze"
const BACKEND_URL_account = environment.apiUrl + "/account";
const BACKEND_URL_maintenance = environment.apiUrl + "/maintenance"

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {

  private isAuthenticated = false;
  private token: string;
  private tokenTimer: any;
  private userId: string;
  private defaultProp: string;
  private userName: string;
  private userEmail: string;
  private verificationmessage: string;
  private Message: string;
  isLogin=false; 
  isGoogleLogin=false;
  public authStatusListener = new Subject<boolean>();
  private messageListener = new Subject<{ messagedata: string }>();
  private UsernameListner = new Subject<{ Name: string; Email: string, Picture: string, SigningWay: string }>();
  private VerificationMessageListner = new Subject<{ VerificationMessage: string; Code: String; }>();

  private propertyDD: PropertyDropDown[] = [];
  private propertyDDUpdated = new Subject<{ propertyDD: PropertyDropDown[]; }>();

  constructor(private commonServ: CommonService, private http: HttpClient, private router: Router,
    private socialAuthService: AuthService, private propertyServ: PropertyService) { }

  getToken() {
    return this.token;
  }

  getIsAuth() {
    return this.isAuthenticated;
  }

  getUserId() {
    return this.userId;
  }

  getAuthStatusListener() {
    return this.authStatusListener.asObservable();
  }

  getUsernameListner() {
    return this.UsernameListner.asObservable();
  }

  getVerificationMessageListner() {
    return this.VerificationMessageListner.asObservable();
  }

  getMessageListner() {
    return this.messageListener.asObservable();
  }

  createUser(UserName: string, Email: string, UserPassword: string, signingWay: string, profile_picture: string) {
    const authData: AuthData = { "Profile": { "UserName": UserName, "Email": Email, "UserPassword": UserPassword, "signingWay": signingWay, "profile_picture": profile_picture } };
    return this.http.post<{ Response: any }>(BACKEND_URL1 + "/createBucket", authData)
  }

  login(email: string, password: string, checked: boolean) {
    const authData: AuthLoginData = { name: name, email: email, password: password };
    this.http
      .post<{ Response: any, Code: string, token: string; expiresIn: number; userId: string; name: string; message: string }>(
        BACKEND_URL + "/login",
        authData
      )
      .subscribe(
        response => {
          // console.log("LogIn Response:- ")
          // console.log(response);
          const token = response.token;
          this.token = token;
          if (token) {
            const expiresInDuration = response.expiresIn;
            this.setAuthTimer(expiresInDuration);
            this.isAuthenticated = true;
            this.userId = response.userId;
            this.authStatusListener.next(true);            
           // this.defaultProp;
            const now = new Date();
            const expirationDate = new Date(
              now.getTime() + expiresInDuration * 1000
            );
            this.isLogin=true;
            this.defaultProperty(token,expirationDate,authData.email,this.isLogin);
           
            // this.saveAuthData(token, expirationDate, this.userId, this.defaultProp, authData.email);
            // this.router.navigate(["/app/dashboard"]);
          }
          else {
            if (response.Response.Code == "1030")
              this.commonServ.showMessage("Username or password is Incorrect", "Retry");
            else if (response.Response.Code == "1013")
              this.commonServ.showMessage("Email Id not registered with us.", "Register Now");
            else if (response.Response.Code == "1031")
              this.commonServ.showMessage("Email is Not Verified. Please check your mail inbox to validate your account.", "OK");
            else
              this.commonServ.showMessage("Sorry We are not able to connect to our Server. Please try again later!", "Retry");
            this.Message = response.Response.message
            this.messageListener.next({ messagedata: this.Message });
            this.authStatusListener.next(true);
            return;
          }
        },
        error => {
          this.commonServ.showMessage("Sorry We are not able to connect to our Server. Please try again later!", "Retry");
          this.authStatusListener.next(false);
        }
      );
  }

  isEmailExists(email: string) {
    //this.logout();
    const authData = { email: email };
    this.http
      .post<{ Response: any }>(
        BACKEND_URL + "/userExistance",
        authData
      ).subscribe(response => {
        console.log(response);
        if (response != null && response.Response.Code === '1000') {
          if (response.Response.IsExists == 'Yes') {
            this.sendToDashBoard(response.Response.token, response.Response.expiresIn, response.Response.userId, authData.email)
            // this.token = response.Response.token;
            // if (this.token) {
            //   const expiresInDuration = response.Response.expiresIn;
            //   this.setAuthTimer(expiresInDuration);
            //   this.isAuthenticated = true;
            //   this.userId = response.Response.userId;
            //   this.authStatusListener.next(true);
            //   this.defaultProperty();
            //   this.defaultProp;
            //   const now = new Date();
            //   const expirationDate = new Date(
            //     now.getTime() + expiresInDuration * 1000
            //   );
            //   this.commonServ.showMessage("Authencation Successful", "Welcome");
            //   this.saveAuthData(this.token, expirationDate, this.userId, this.defaultProp, authData.email);
            //   // this.socialAuthService.signOut();
            //   this.router.navigate(["/app/dashboard"]);
            // }
          }
          else {
            this.commonServ.showMessage("Email Id not registered with us.", "Register Now");
            //this.createUser("Google", email, "", "google");
            // this.router.navigate(["/app/dashboard"]);
          }
        }
      })
  }

  sendToDashBoard(token: any, expiresIn: any, userId: any, email: any) {
    this.token = token;
    if (this.token) {
      const expiresInDuration = expiresIn;
      this.setAuthTimer(expiresInDuration);
      this.isAuthenticated = true;
      this.userId = userId;
      this.authStatusListener.next(true);
     
      //this.defaultProp;
      const now = new Date();
      const expirationDate = new Date(
        now.getTime() + expiresInDuration * 1000
      );
      this.isGoogleLogin=true
      this.defaultProperty(this.token,expirationDate,email,this.isGoogleLogin);
      this.commonServ.showMessage("Authencation Successful", "Welcome");
      //this.saveAuthData(this.token, expirationDate, this.userId, this.defaultProp, email);
      // this.socialAuthService.signOut();
      this.router.navigate(["/app/dashboard"]);
    }
  }

  autoAuthUser() {
    const authInformation = this.getAuthData();
    if (!authInformation) {
      return;
    }
    const now = new Date();
    const expiresIn = authInformation.expirationDate.getTime() - now.getTime();
    if (expiresIn > 0) {
      this.token = authInformation.token;
      this.isAuthenticated = true;
      this.userId = authInformation.userId;
      this.setAuthTimer(expiresIn / 1000);
      this.authStatusListener.next(true);
    }
  }

  logout() {
    this.token = null;
    this.isAuthenticated = false;
    this.authStatusListener.next(false);
    this.userId = null;
    this.userName = null;
    clearTimeout(this.tokenTimer);
    this.clearAuthData();
    this.router.navigate(["/"]);
    this.commonServ.showMessage("Successfully LoggedOut", "OK");
  }

  getusername() {
    const userId = localStorage.getItem("userId");
    this.http.get<{ message: string; name: any; email: string; Picture: string; SigningWay: string }>(
      BACKEND_URL + "/username/" + userId)
      .subscribe(username => {
        this.userName = (username.name)?username.name:"";
        this.userEmail = username.email;
        this.UsernameListner.next({
          Name: this.userName,
          Email: this.userEmail,
          Picture: username.Picture,
          SigningWay: username.SigningWay
        });
      });
  }

  private defaultProperty(token,expirationDate,email,is_Login) {
    this.propertyServ.getPropertyList();
    this.propertyServ.getpropertyListListner()
      .subscribe((propertyListData: { propertyDD: PropertyDropDown[]; }) => {
        for (let i = 0; i < propertyListData.propertyDD.length; i++) {
          if (propertyListData.propertyDD[i].Default == "Yes") {
            this.defaultProp = propertyListData.propertyDD[i].id;
            if(is_Login){
              this.saveAuthData(token, expirationDate, this.userId, this.defaultProp, email);
              this.router.navigate(["/app/dashboard"]);
              this.isLogin=false;
              this.isGoogleLogin=false;
            }            
            localStorage.setItem("propertyId", this.defaultProp);
            localStorage.setItem("selectedPropertyFrequency", propertyListData.propertyDD[i].RentFrequency);
            
          }
          is_Login=false;
        }
      });
  }

  private setAuthTimer(duration: number) {
    // console.log("Setting timer: " + duration);
    this.tokenTimer = setTimeout(() => {
      this.logout();

    }, duration * 1000);
  }

  private saveAuthData(token: string, expirationDate: Date, userId: string, defaultPr: string, emailvalue: string) {
    localStorage.setItem("propertyId", defaultPr);
    localStorage.setItem("token", token);
    localStorage.setItem("expiration", expirationDate.toISOString());
    localStorage.setItem("userId", userId);
    localStorage.setItem("emailid", emailvalue);
  }

  private clearAuthData() {
    //this.defaultProp =null;
    localStorage.removeItem("propertyId");
    localStorage.removeItem("token");
    localStorage.removeItem("expiration");
    localStorage.removeItem("userId");
    localStorage.removeItem("emailid");
    localStorage.removeItem("IsNotifReceived");
    localStorage.removeItem("selectedPropertyFrequency");
  }

  private getAuthData() {
    const token = localStorage.getItem("token");
    const expirationDate = localStorage.getItem("expiration");
    const userId = localStorage.getItem("userId");
    const emailId = localStorage.getItem("emailid");
    if (!token || !expirationDate) {
      return;
    }
    return {
      token: token,
      expirationDate: new Date(expirationDate),
      userId: userId,
      emailId: emailId
    };
  }
  emailVerify(VerificationToken) {
    this.http.put<{ Response: any }>(BACKEND_URL1 + "/verifyUser", {}, { params: { VerificationToken: VerificationToken } })
      .subscribe(data => {
        if (data.Response.Code == '1000') {
          this.verificationmessage = data.Response.Details;
          this.VerificationMessageListner.next({
            VerificationMessage: this.verificationmessage,
            Code: data.Response.Code
          });
        }
        else {
          this.verificationmessage = data.Response.message;
          this.VerificationMessageListner.next({
            VerificationMessage: this.verificationmessage,
            Code: data.Response.Code
          });
        }
      });
  }

  forgotPassword(email: string) {
    let forgotPasswordData
    forgotPasswordData = {
      Email: email
    }
    return this.http.post<{ Response: any }>(BACKEND_URL_account + "/forgotPassword", forgotPasswordData)
  }

  changePassword(password, confirmPassword, oldpassword) {
    let changePassword
    changePassword = {
      Email: localStorage.getItem("emailid"),
      NewPassword: password,
      ConfirmNewPassword: confirmPassword,
      OldPassword: oldpassword,
    }
    return this.http.post<{ Response: any }>(BACKEND_URL_account + "/changePassword", changePassword)
  }

  resetPassword(VerificationToken, confirmPassword) {
    let resetPassword
    resetPassword = {
      Profile: {
        VerificationCode: VerificationToken,
        UserPassword: confirmPassword,
      }
    }
    return this.http.post(BACKEND_URL_account + "/resetPassword", resetPassword)
  }

  getAllNotification() {
    return this.http.get<{ code: string, UserNotifications: any }>(BACKEND_URL_maintenance + "/getAllNotifications/" + localStorage.getItem("userId"))
  }
}
